import { render } from "./Cbhiservicespage.vue?vue&type=template&id=ce915662&scoped=true"
import script from "./Cbhiservicespage.vue?vue&type=script&lang=js"
export * from "./Cbhiservicespage.vue?vue&type=script&lang=js"

import "./Cbhiservicespage.vue?vue&type=style&index=0&id=ce915662&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce915662"]])

export default __exports__